/* eslint-disable max-len */
import { get } from '@bingads-webui-universal/primitive-utilities';

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function getEnum(i18n, enumType, enumItem) {
  return i18n.get(`Schema_Enum_${capitalize(enumType.toString())}_${capitalize(enumItem.toString())}`);
}

function getEnumDescription(i18n, enumType, enumItem) {
  return i18n.get(`Schema_Enum_${capitalize(enumType.toString())}_${capitalize(enumItem.toString())}_Description`);
}

function toSchema(schemaOrType = {}) {
  if (typeof schemaOrType === 'string') {
    return {
      name: schemaOrType,
    };
  }

  if (!schemaOrType.name) {
    throw new TypeError(`The schema should have "name" property, but is ${JSON.stringify(schemaOrType)}`);
  }

  return schemaOrType;
}

function toArray(stringOrArray) {
  return Array.isArray(stringOrArray) ? stringOrArray : [stringOrArray];
}

function getType(i18n, schemaOrType) {
  return i18n.get(`Schema_${toSchema(schemaOrType).name}`);
}

function getPropertySchema(schema, property) {
  const standardPropertySchema = get(schema, ['properties', property]);

  if (standardPropertySchema) {
    const resolvedSchema = standardPropertySchema.schema ?
      standardPropertySchema.schema : // for our non-standard schema format
      standardPropertySchema;

    return resolvedSchema.name ? resolvedSchema : { ...resolvedSchema, name: property };
  }
  return {
    name: property, // most non-primitive property has same name with it's type
  };
}

// For Campaign.PerformanceMetrics.Clicks
// it would use i18n key first exists in following list
//  Schema_Campaign_Property_PerformanceMetrics.Clicks
//  Schema_PerformanceMetrics_Property_Clicks
//  Schema_Clicks
function getProperty(i18n, schemaOrType, property) {
  const schema = toSchema(schemaOrType);
  const arrProperty = toArray(property);

  const exact = i18n.get(`Schema_${schema.name}_Property_${arrProperty.join('.')}`);

  if (exact) {
    return exact;
  }

  const topLevelPropertySchema = getPropertySchema(schema, arrProperty[0]);

  return arrProperty.length > 1 ?
    getProperty(i18n, topLevelPropertySchema, arrProperty.slice(1)) :
    getType(i18n, topLevelPropertySchema);
}

function getValue(i18n, schemaOrType, property, value) {
  const schema = toSchema(schemaOrType);

  return i18n.get(`Schema_${schema.name}_Property_${property}_Value_${capitalize(value.toString())}`) ||
    getEnum(i18n, get(schema, ['properties', property, 'enumType']) || property, value) || // most enum property has same name with it's type
    String(value); // default to value itself, useful for already-localized value or no-need-to-localize value
}

function getValueDescription(i18n, schemaOrType, property, value) {
  const schema = toSchema(schemaOrType);

  return i18n.get(`Schema_${schema.name}_Property_${property}_Value_${capitalize(value.toString())}_Description`) ||
    getEnumDescription(i18n, get(schema, ['properties', property, 'enumType']) || property, value) || // most enum property has same name with it's type
    String(value); // default to value itself, useful for already-localized value or no-need-to-localize value
}

export function constructSchemaI18n({ _, i18n }) {
  return {
    type: _.partial(getType, i18n),
    property: _.partial(getProperty, i18n),
    value: _.partial(getValue, i18n),
    enum: _.partial(getEnum, i18n),
    // deprecated
    enumMappedString: _.partial(getEnum, i18n),

    valueDescription: _.partial(getValueDescription, i18n),
    enumDescription: _.partial(getEnumDescription, i18n),
  };
}

export function load(name, req, onload, config) {
  if (config.isBuild) {
    onload();
  } else {
    req([
      'lib/underscore',
      `component/i18n/loader!component/schema-i18n-${name}`,
    ], (_, i18n) => {
      onload(constructSchemaI18n({ _, i18n }));
    });
  }
}
